import React from "react";

function AppleAppSite() {
  const appleAppSiteText = `
  {
    "applinks": {
      "apps": [],
      "details": [
        {
          "appID": "5F3QMU364R.com.ios.mobile360",
          "paths": ["*"]
        }
      ]
    }
  }
  `;
  return <div>{appleAppSiteText}</div>;
}

export default AppleAppSite;
